import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppMenuItem } from '../../models/menu.model';
import { MenuService } from '../service/menu.service';
import { AppMenuitem } from './app.menuitem';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitem, RouterModule, TranslateModule],
  template: `
    <div class="flex h-full flex-col">
      <ul class="layout-menu flex-grow overflow-y-auto">
        <ng-container *ngFor="let item of model; let i = index">
          <li
            *ngIf="item.isCategoryHeader && item.label"
            class="layout-menuitem-root-text px-3 py-2 text-xs font-semibold uppercase text-surface-400 dark:text-surface-500"
          >
            {{ item.label | translate }}
          </li>
          <li
            app-menuitem
            *ngIf="!item.isCategoryHeader && !item.separator"
            [item]="item"
            [index]="i"
            [root]="!item.routerLink"
          ></li>
          <li
            *ngIf="item.separator"
            class="menu-separator"
          ></li>
        </ng-container>
      </ul>
    </div>
  `
})
export class AppMenu implements OnInit {
  model: AppMenuItem[] = [];

  constructor(private menuService: MenuService) {}

  ngOnInit(): void {
    this.model = this.menuService.getMenu();
  }
}
